export default __webpack_public_path__ + "static/media/dctr.3d519199.png";